import type { NavItem } from '../types/navItem'
import { NavItemAccessor } from '../types/navItemAccessor'
import type { NavItemSeparator } from '../types/navItemSeparator'

export const createSeparatorItem = (groupIndex: number): NavItem<NavItemSeparator> => ({
  accessor: NavItemAccessor.Separator,
  children: null,
  id: `separator-${groupIndex}`,
  value: NavItemAccessor.Separator,
})
